/// <reference path="../definitions/irep/irep.d.ts" />
/// <reference path="../public/irep.ts" />
/// <reference path="../public/component.ts" />
/// <reference path="../../../../node_modules/foundation-sites/dist/js/foundation.d.ts" />
/// <reference path="../../../../node_modules/foundation-sites/js/foundation.core.js" />

declare var irep: IREP.IREP;
declare var accountSnapshot: IREP.AccountSnapshot;

namespace IREP {
    "use strict";

    interface GotCodeResult {
        font: string;
        localeId: number;
        localeText: string;
        url: string;
        activityCode: string;
    }

    export class AccountSnapshot extends Component {

        private $snapshotDetailsElem: JQuery;
        private $snapshotToggleElem: JQuery;

        private $gotcodeButton: JQuery;
        private $gotcodeInput: JQuery;
        private $gotcodeResult: JQuery;

        private redirectTimeout = 0;

        private $snapshotDetailsToggler: FoundationSites.Toggler;

        private $toggled: boolean;

        constructor(id: string, config: any) {
            super(id);

            // initial start, untoggled/hidden
            this.$toggled = false;

            this.$snapshotDetailsElem = this.$component.find("#account-snapshot-details");
            this.$snapshotToggleElem = this.$component.find("#account-snapshot-toggle, #gotCode_trigger");
            this.setupToggler();

            this.$gotcodeButton = this.$component.find('.got-code-submit');
            this.$gotcodeInput = this.$component.find('.got-code-input');
            this.$gotcodeResult = this.$component.find('.got-code-result');
            this.setupSubmit();
        }

        private setupToggler(): void {
            // fix viewbox for ar-SA
            var viewBox = "19 0 50 50"; //default
            if (irep.options.isRTL) {
                viewBox = "0 0 50 50";
            }
            $("#account-snapshot-toggle-svg").attr("viewBox", viewBox);
            $("#account-snapshot-toggle").fadeIn(); // fade it in after the viewbox gets set or else its off and looks odd

            // call reinit to do the init init. heh, did you see what i did there...
            this.reInitSnapshotDetailsToggler(Foundation.MediaQuery.current);

            // on breakpoint events, reinit
            var that = this;
            $(window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
                // reinit always on breakpoint change
                that.reInitSnapshotDetailsToggler(newSize);
            });
        }
        
        private reInitSnapshotDetailsToggler(currentBreakpoint: string = "large"): void {
            // fix rotator overlay if need be 
            if (this.$toggled) {
                if (currentBreakpoint !== 'small') {
                    $(".rotator-overlay").fadeIn();
                }
                else {
                    $(".rotator-overlay").fadeOut();
                }
            }

            // setup animation classes
            var animationInClass = currentBreakpoint === 'small' ? "hinge-in-from-top" : (irep.options.isRTL ? "hinge-in-from-right" : "hinge-in-from-left");
            var animationOutClass = currentBreakpoint === 'small' ? "hinge-out-from-top" : (irep.options.isRTL ? "hinge-out-from-right" : "hinge-out-from-left");

            // setup click events
            // set click with one, and reinit once animations finish to re-one-click it.
            var that = this;
            this.$snapshotToggleElem.off("click");
            this.$snapshotToggleElem.one("click", function () {
                if (that.$toggled) {
                    $("#toggle-chevron").removeClass('flipped');
                    /*$("#toggle-chevron").attr("transform", "scale(1, 1)");*/ // flip the chevron group on the horizontal axis
                    // remove the black overlay on the rotator
                    $(".rotator-overlay").fadeOut();
                    Foundation.Motion.animateOut(that.$snapshotDetailsElem, animationOutClass, function () {
                        that.$toggled = !that.$toggled; // toggle toggle
                        that.reInitSnapshotDetailsToggler(currentBreakpoint);
                    });
                    
                }
                else {
                    //$("#toggle-chevron").attr("transform", "scale(-1, 1)");
                    $("#toggle-chevron").addClass('flipped');
                    if (currentBreakpoint !== 'small') {
                        $(".rotator-overlay").fadeIn();
                    }
                    Foundation.Motion.animateIn(that.$snapshotDetailsElem, animationInClass, function () {
                        that.$toggled = !that.$toggled; // toggle toggle
                        that.reInitSnapshotDetailsToggler(currentBreakpoint);
                    });
                }
            });
        }


        // ripped code below from v2, added some typescript tweaks
        private setupSubmit(): void {
            this.$gotcodeButton.off().click(() => {
                let code = <string>this.$gotcodeInput.val();
                this.submitCode(code);
                this.setupSubmit();
            });
        }

        private submitCode(code: string): void {
            irep.callApi({ type: 'GET', url: 'promotion/contest/processcode', data: { contestCode: code } }).then((data) => {
                let contestResult = <GotCodeResult>data.contestResult;

                // are we doing this instant contest stuff?
                if (contestResult.activityCode != null) {
                    this.launchQuiz(code, contestResult.activityCode);
                } else {
                    if (contestResult.url != null) {
                        setTimeout(() => {
                            window.location.href = contestResult.url;
                        }, this.redirectTimeout);
                    }

                    this.$gotcodeResult.html(contestResult.localeText);
                    this.$gotcodeResult.css('color', contestResult.font);
                }
            });
        }

        private launchQuiz(gotCode: string, activityCode: string) {
            irep.callApi({
                url: "quiz",
                type: "GET",
                data: {
                    activityCode: activityCode
                }
            }).done(function (d) {
                let options = $.extend({}, d,
                    {
                        allowReview: true,
                        timeDivisor: 1,
                        apiRoot: irep.options.apiUrl,
                        quizSelector: '#contentContainer, #footer, #header, #mobileAppContainer',
                        quizBodyClass: "videoquiz",
                        returnUrl: "javascript:window.location=window.location.href"
                    });
                let quiz = new (<any>irep).Quiz(options);
                quiz.startQuiz();

                $(quiz).on("irep.quiz.results", function (e, result) {
                    if (result.pass) {
                        irep.callApi({
                            url: "promotion/ftf-got-code/award-points",
                            type: "GET",
                            data: {
                                gotCode: gotCode,
                                activityCode: activityCode
                            }
                        })
                    }
                });
            });
        }
    }
}